module.exports = __webpack_public_path__ + "img/Huaixin_Dang.9597b19d.png";